var csrf_token,
  ContactForm = {},
  mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;

var formElem = document.querySelector('#press-page-form');
ContactForm.formObj = document.getElementById('press-page-form');
ContactForm.formObjError = document.querySelector(".contact-form");
ContactForm.emailField = document.getElementById("form-email");
ContactForm.requestType = document.getElementById("request_type");
ContactForm.utf8 = document.getElementById("utf_no");
ContactForm.authenticity = document.getElementById("authenticity_token");

/**
 * Recaptcha File load
 */
window.addEventListener("load", function() {
  // load recaptcha JS after page load
  document.addEventListener("click", function () {
    if (typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
  });
});

// email blur validation
if (ContactForm.emailField) {
  ContactForm.emailField.addEventListener("blur", function(event) {
    var validEmail = true,
      that = this,
      submitBtn = document.getElementById("contact-submit"),
      emailError = document.getElementById("email-error");

    //false valid dataset
    that.dataset.notvalid = "0";

    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
      validEmail = false;
      
      that.classList.add("error-border");
      that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail : Messages.salesAndSupportPage.invalidEmail) + '</span>');
    } else {
      that.classList.remove("error-border");
    }

    if (validEmail) {
      //Disable submit button
      if (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        submitBtn.dataset.valueText = submitBtn.value;
        submitBtn.value = Messages.salesAndSupportPage.validateText;
      }

      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value),
        {},
        true,
        {
          "X-CSRF-Token": csrf_token,
          "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
        },
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);

          //remove disable
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.value = submitBtn.dataset.valueText;
          }

          if (dataRequest.valid === false) {
            that.dataset.notvalid = "1";

            that.classList.add("error-border");
            if (that.parentNode.getElementsByClassName("error-message").length === 0) {
              that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
            }
          }
        },
        function() {}
      );
    }
  });
}

// Success message for user token.
var success = function(data) {
  var dataRequest = bsLib.JSONParse(data.response);
  ContactForm.authenticity.value = dataRequest.csrf_token;
  csrf_token = dataRequest.csrf_token;
};

// Custom Error message for user token.
var error = function() {
  return Messages.salesAndSupportPage.invalidUserToken;
};

// XHR request for user token
bsLib.ajax(
  "GET",
  bsLib.railsHost() + "/user/token.json",
  {},
  false,
  {},
  success,
  error
);

var PartnersContact = (function(csrf_token, ContactForm) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields
  };

  function init() {

    var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '',
      form_requestHeader = {
      "X-CSRF-Token" : csrf_token,
      "content-type" : "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
    };

    if (grecaptchaResponse.length === 0) {
      new bsAlert({
        alertType: "error",
        timeout: 5000,
        text: Messages.salesAndSupportPage.noRecaptcha
      });

      return false;
    }

    var form_data = {
      email: document.getElementById("form-email").value.trim(),
      authenticity_token: document.getElementById("authenticity_token").value, 
      utf8: document.getElementById("utf_no").value, 
      form_name: document.getElementById("request_type").value,
      "g-recaptcha-response": grecaptchaResponse,
      ga_cid: bsLib.GAClientID()
    };
    
    var form_success = function(data) {
      var dataRequest = bsLib.JSONParse(data.response);
      if(dataRequest.success === true) {
        var modalContainer = document.querySelector(".thank-you-modal"),
        modal = new tingle.modal({
          onClose: function() {
            modal.destroy();
          }
        });
        modal.setContent(modalContainer.innerHTML);
        modal.open();
      
        _afterSubmitSuccess();
        _logFormSubmit("FormSubmitSuccess");
      } else {
        console.error("form success failed");
      }
      
    };

    var form_error = function() {
      _logFormSubmit("FormSubmitError");
    };
    
    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/capture-lead",
      form_data,
      false,
      form_requestHeader,
      form_success,
      form_error
    );

  }

  function _validateFields() {
    var formValid = true,
      emailError = document.getElementById("email-error");

    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    if (ContactForm.emailField.value === "") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.noemail
      );
    } else if (!ContactForm.emailField.value.match(mailformat)) {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    } else if (ContactForm.emailField.dataset.notvalid === "1") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    } else {
      ContactForm.emailField.classList.remove("error-border");
      if (emailError) {
        emailError.remove();
      }
    }

    return formValid;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);
  }

  function _afterSubmitSuccess() {
    resetForm();
  }

  function resetForm() {
    ContactForm.formObj.reset(); //Reset form

    if (typeof grecaptcha !== "undefined") {
      grecaptcha.reset();
    }
  }

  function _logFormSubmit(status) {
    if (typeof ga !== "undefined") {
      ga('browserstack.send', 'event', {
        'eventCategory': 'Press Page Form', 'eventAction': 'CtaClick', 'eventLabel': 'Submit'
      });
    }
  }
})(csrf_token, ContactForm);

var recaptchaCallback = function() {
  return PartnersContact.init();
};

//Reset captcha if expired
var expiredCaptchaCallback = function() {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};

formElem.addEventListener("submit", function (e) {
  e.preventDefault();

  if (!PartnersContact.validateFields()) {
    return false;
  }

  if (typeof grecaptcha !== "undefined") {
    grecaptcha.execute();
  }
  return false;
});